import styled from 'styled-components';

export const Wrapper = styled.div`
  margin: 8px;
  background: white;
  box-sizing: border-box;
  height: calc(100vh - 16px);
`

export const Content = styled.div``
